import { unwrapResult } from "@reduxjs/toolkit"
import { Button, Checkbox, Col, Form, Input, Popover, Radio, Row, Select, Space, Table, notification } from "antd"
import React, {
  ReactElement,
  useContext,
  useEffect,
  useState,
  useRef,
  useMemo,
} from "react"
import { useDispatch, useSelector } from "react-redux"
import { selectTenantName } from "../../../app/applicationSlice"
import { RootDispatch } from "../../../app/store"
import { PrintFrame, PrintFrameRef } from "../../print/PrintFrame"
import {
  DateRangeFieldName,
  DateRangeNoYearTypes,
  DateRangeType,
  DateSelect,
  getDateRange,
  TJFXTime,
} from "../../../compnents/form/DateSelect"
import { ThemeContext } from "../../../theme/ThemeContext"
import styles from "./doctoAchievement.module.css"
import { getDoctorAchievementAsync, getDoctorAchievementExportAsync, getDoctorAchievementDetailAsync, getDoctorAchievementDetailExportAsync } from "./achievement"
import moment from "moment"
import { AGColumns, DoctorAchievementColumns } from "./column"
import { getCheckPermissionAsync } from "../../FunctionSetting/dataPermission/dataPermissionSlice"
import { SJQXChecks } from "../../../models/dataPersion"
import { getSortColumnList } from "../../../models/common"
import SimpleAgGrid from "../../../compnents/simpleTable/SimpleAgGrid"
import { getPageColumnListAsync, getSubmitPageColumnListAsync } from "../../transactionQuery/transactionQuerySlice"
import { FilterColumn } from "../../../compnents/filterForm/filterForm"
import { getDoctorList } from "../DoctorAccont/doctorAuditSlice"
import { QuestionCircleTwoTone, SettingOutlined } from "@ant-design/icons"
import { SettingsComputeModeModal } from "./settingsModal"

export const DoctorAchievement = (): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [form] = Form.useForm()

  const [timeHead, timeTail] = getDateRange(DateRangeType.Today)

  const [params, setParams] = useState({
    timeHead,
    timeTail,
    [DateRangeFieldName]: DateRangeType.Today,
  })

  const name = useSelector(selectTenantName)

  const [data, setData] = useState<any[]>([])

  const printRef = useRef<PrintFrameRef>(null)

  const [CKLRSJData, setCKLRSJData] = useState<any>(true)

  const [categoryValue, setCategoryValue] = useState(false) //按处方分类

  const [viewType, setViewType] = useState<'summary' | 'document'>('summary') // 汇总/单据视图

  const [pageLoading, setPageLoading] = useState(false) //表格 loading

  const [exportLoading, setExportLoading] = useState(false) //导出 loading

  const [doctors, setDoctors] = useState<any[]>([])

  const [DJparams, setDJparams] = useState({
    current: 1,
    size: 10,
    timeHead,
    timeTail,
    [DateRangeFieldName]: DateRangeType.Today,
  })

  const [DJpage, setDJpage] = useState<any>()

  const [summary, setSummary] = useState<any>()

  const Tips = (title: string) => (
    <>
      {title}
      <Popover
        placement='top'
        content='计提金额：用于员工业绩评估，作为提成计算的基数，其数值为所有开票项目金额之和。'
      >
        <QuestionCircleTwoTone style={{ marginLeft: '5px' }} />
      </Popover>
    </>
  )
  // 所有的列表
  const listData: any = [
    {
      headerName: '序号',
      width: 80,
      minWidth: 80,
      field: 'index',
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '科室',
      field: 'departmentName',
      width: 120,
      minWidth: 120,
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '医生姓名',
      field: 'doctorName',
      width: 120,
      minWidth: 120,
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '收费时间',
      field: 'settlementTime',
      minWidth: 160,
      visible: true,
    },
    {
      headerName: '收费类型',
      field: 'feeType',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '患者姓名',
      field: 'patientName',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '病历号',
      field: 'medicalNumber',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '性别',
      field: 'gender',
      minWidth: 90,
      visible: true,
    },
    {
      headerName: '年龄',
      field: 'age',
      minWidth: 90,
      visible: true,
    },
    {
      headerName: '手机号',
      field: 'phone',
      minWidth: 150,
      visible: true,
    },
    {
      headerName: '接诊类型',
      field: 'furtherConsideration',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '总金额',
      field: 'totalPayAmount',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '应收金额',
      field: 'shouldPayAmount',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '本次实收',
      field: 'realPayAmount',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: Tips('计提金额'),
      field: 'commissionAmount',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '西药费',
      field: 'billingCategory01',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '中成药',
      field: 'billingCategory02',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '中草药',
      field: 'billingCategory03',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '其他药品',
      field: 'otherMedicines',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '挂号费',
      field: 'billingCategory30',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '代煎费',
      field: 'billingCategory97',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '诊查费',
      field: 'billingCategory04',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '检查费',
      field: 'billingCategory06',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '治疗费',
      field: 'billingCategory05',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '化验费',
      field: 'billingCategory07',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '护理费',
      field: 'billingCategory34',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '手术费',
      field: 'billingCategory08',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '放射费',
      field: 'billingCategory09',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '输血费',
      field: 'billingCategory10',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '输氧费',
      field: 'billingCategory11',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: 'B超费',
      field: 'billingCategory23',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '心电图费',
      field: 'billingCategory24',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '透析费',
      field: 'billingCategory26',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '化疗费',
      field: 'billingCategory27',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '麻醉费',
      field: 'billingCategory28',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '注射费',
      field: 'billingCategory25',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '其他费',
      field: 'billingCategory99',
      minWidth: 100,
      visible: true,
    },

  ]?.map((item: any, index: number) => ({
    ...item,
    index: index + 1,
  }))

  const allData = listData
  // 默认要展示的列的值
  const selectColumns = allData?.filter((v: any) => v.visible)?.map((item: any) => item.field) || []

  const [allColumnList, setAllColumnList] = useState<any[]>([]) //筛选列所有的数据

  // 筛选列所有的数据
  const [filterColumnList, setFilterColumnList] = useState<any[]>([])

  const [filterSelectList, setFilterSelectList] = useState<any[]>([]) //筛选列所有的数据

  // 查看手机号
  const [CKHZSJHData, setCKHZSJHData] = useState<any>({})

  // 设置弹窗是否展示
  const [settingsVisible, setSettingsVisible] = useState<boolean>(false)

  useEffect(() => {
    setViewType('summary')
  }, [])

  // 获取汇总数据
  const getData = () => {
    try {
      setPageLoading(true)
      dispatch(getDoctorAchievementAsync(params))
        .then(unwrapResult)
        .then((data: any) => {
          setData(data)
        })
        .finally(() => setPageLoading(false))
    } catch {
      // do nothing.
    }
  }

  useEffect(() => {
    if (viewType == 'summary') {
      // 汇总查看是否展示利润
      getCheckPermissionFn()
    } else {
      //单据统计分析手机号
      dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.TJFXCKHRSJH }))
        .then(unwrapResult)
        .then((res: any) => {
          setCKHZSJHData(res)
        })
    }
  }, [viewType])

  // 获取查看利润数据权限
  const getCheckPermissionFn = () => {
    dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.CKLRSJ }))
      .then(unwrapResult)
      .then((res: any) => {
        setCKLRSJData(res)
      })
  }

  // 查看单据数据
  const getDoctorAchievementDetail = () => {
    dispatch(getDoctorAchievementDetailAsync(DJparams))
      .then(unwrapResult)
      .then((data: any) => {
        setDJpage({ items: data?.records?.filter((v: any) => v?.feeType != 99) || [], total: data?.total || 0 })
        setSummary(data?.records?.filter((v: any) => v?.feeType == 99)?.[0] || {})
      })
      .finally(() => setPageLoading(false))
  }

  // 获取汇总数据
  useEffect(() => {
    getData()
  }, [params])

  useEffect(() => {
    if (viewType == 'document') {
      setPageLoading(true)
      getDoctorAchievementDetail()
      getPageColumnList()
    }
  }, [DJparams])

  useEffect(() => {
    form.setFieldsValue(params)
  }, [])

  useEffect(() => {
    // 获取医生列表
    if (viewType == 'document') {
      try {
        dispatch(getDoctorList())
          .then(unwrapResult)
          .then((doctors) => setDoctors(doctors))
      } catch {
        // do nothing.
      }
    }
  }, [viewType])

  const table = (type = false) => (
    <>
      <Table
        className={type ? styles.tables : styles.table}
        pagination={false}
        rowClassName={(e) =>
          e.treatmentDoctorName === '合计' ? styles.total : e.categoryName === '分类合计'
            ? styles.highlight
            : ''
        }
        loading={pageLoading}
        dataSource={data}
        bordered
        rowKey={(_, i) => `${i}}`}
        style={{ flex: 1, overflow: "auto" }}
        columns={DoctorAchievementColumns(categoryValue ? 1 : 0, data, CKLRSJData)}
      />
    </>
  )

  const tablePrint = (type = false) => (
    <>
      <Table
        className={type ? styles.tables : styles.table}
        pagination={false}
        rowClassName={(e) =>
          e.treatmentDoctorName === '合计' ? styles.total : e.categoryName === '分类合计'
            ? styles.highlightPrint
            : ''
        }
        loading={pageLoading}
        dataSource={data}
        bordered
        rowKey={(_, i) => `${i}}`}
        style={{ flex: 1, overflow: "auto" }}
        columns={DoctorAchievementColumns(categoryValue ? 1 : 0, data, CKLRSJData)}
      />
    </>
  )

  const outClued = () => {
    setExportLoading(true)
    dispatch(getDoctorAchievementExportAsync(params))
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '医生业绩统计.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        return
      })
      .finally(() => setExportLoading(false))
  }

  const exportExcel = () => {
    setExportLoading(true)
    dispatch(getDoctorAchievementDetailExportAsync(DJparams))
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '医生业绩统计.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        return
      })
      .finally(() => setExportLoading(false))
  }

  const submitPageList = (data: any) => {
    const params = {
      pageName: 'doctorAchievementPage',
      configJson: JSON.stringify(data),
    }
    dispatch(getSubmitPageColumnListAsync({
      ...params,
    }))
      .then(unwrapResult)
      .then((v: any) => {
        getPageColumnList(v?.id)
      })
  }

  const getPageColumnList = (id?: any) => {
    dispatch(getPageColumnListAsync({
      id: id ? id : undefined,
      pageName: 'doctorAchievementPage',
    }))
      .then(unwrapResult)
      .then((v: any) => {
        const data: any = v?.configJson ? JSON.parse(v?.configJson) : []
        const filterList = data?.filter((n: any) => n?.visible)
        const columns = filterList?.map((n: any) => n?.field)
        const resetData = data?.map(((v: any) => {
          const sameFileds = allData?.find((item: any) => item?.field == v?.field)
          return {
            ...v,
            minWidth: sameFileds?.minWidth || v?.minWidth,
            width: sameFileds?.width || v?.width,
            headerName: sameFileds?.headerName || v?.headerName,
          }
        }))
        // 所有的数据
        setAllColumnList(data?.length ? resetData : allData)
        // 筛选后存在后端的数据
        setFilterColumnList(filterList?.length ? filterList : allData)
        // 选中的值
        setFilterSelectList(columns?.length ? columns : selectColumns)
      })
      .catch(() => {
        setAllColumnList(allData)
        setFilterColumnList(allData)
        setFilterSelectList(selectColumns)
      })
      .finally(() => {
        setPageLoading(false)
      })
  }
  return (
    <Col
      style={{
        height: "calc(100% - 30px)",
        padding: "20px 15px",
        borderRadius: theme.br,
        backgroundColor: theme.pn,
        marginTop: 10,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Form
        form={form}
        onFinish={(values) => {
          const monthDiff = moment(values?.timeTail).diff(moment(values?.timeHead), 'months', true)
          if (monthDiff > 1) {
            notification.error({
              message: '时间间隔不能超过1个月',
              duration: 3,
            })
            return
          }
          if (!values?.timeHead && values?._dateRange == 6) {
            return
          }
          console.log(values)
          if (viewType == 'summary') {
            setParams({ ...params, ...values, category: categoryValue ? 1 : undefined })
          } else {
            setDJparams({ ...DJparams, ...values, current: 1 })
          }
        }
        }
      >
        <Row
          style={{ marginBottom: 10 }}
          align="middle"
          justify="space-between"
        >
          {viewType == 'summary' ?
            <Space>
              <DateSelect
                style={{ width: "8.5rem" }}
                labelPrefix=""
                allowClear={false}
                options={DateRangeNoYearTypes}
                namePrefix="time"
                placeholder="业绩统计-时间"
                initialValue={DateRangeType.Today}
                onChange={form.submit}
              />
              <Checkbox
                disabled={pageLoading}
                checked={categoryValue}
                onChange={(e) => {
                  setCategoryValue(e.target.checked)
                  form.submit()
                }}
              >
                按处方分类
              </Checkbox>
              <Button type="primary" onClick={form.submit} loading={pageLoading}>
                查询
              </Button>
            </Space> :
            <Space>
              <Form.Item noStyle name='patientName'>
                <Input
                  autoComplete='off'
                  maxLength={20}
                  placeholder='患者姓名'
                  style={{ width: '10rem' }}
                  allowClear
                  onChange={() => {
                    form.submit()
                  }}
                />
              </Form.Item>
              <Form.Item name='doctorId' noStyle>
                <Select
                  onChange={form.submit}
                  style={{ width: "8.5rem" }}
                  placeholder='医生姓名'
                  allowClear
                >
                  {doctors.map((d) => (
                    <Select.Option
                      key={d.id}
                      value={d.id}
                    >
                      {d.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name='recordType' noStyle>
                <Select
                  onChange={form.submit}
                  style={{ width: "8.5rem" }}
                  placeholder='收费类型'
                  allowClear
                >
                  <Select.Option value={0}>收费</Select.Option>
                  <Select.Option value={1}>补交</Select.Option>
                  <Select.Option value={2}>退费</Select.Option>
                </Select>
              </Form.Item>
              <DateSelect
                style={{ width: "8.5rem" }}
                labelPrefix=""
                allowClear={false}
                options={DateRangeNoYearTypes}
                namePrefix="time"
                placeholder="时间"
                initialValue={DateRangeType.Today}
                onChange={form.submit}
              />
              <Button type="primary" onClick={form.submit} loading={pageLoading}>
                查询
              </Button>
              <FilterColumn
                filterColumn={allColumnList}
                filterSelectList={filterSelectList}
                // 筛选列变化时的数据
                onColumnVisibilityChange={(v: any) => {
                  // 以 filterColumn 的顺序为基准，用 v 中的字段顺序重排，并保留 filterColumn 的 visible 状态
                  const sortList = allColumnList?.map((val: any) => {
                    return {
                      ...val,
                      visible: v?.includes(val.field)
                    }
                  })
                  submitPageList && submitPageList(sortList)
                }}
              />
            </Space>}
          <Space>
            <Radio.Group
              value={viewType}
              onChange={(e) => {
                setViewType(e.target.value)
                if (e.target.value == 'summary') {
                  form.setFieldsValue({
                    timeHead: params.timeHead,
                    timeTail: params.timeTail,
                    [DateRangeFieldName]: params[DateRangeFieldName],
                  })
                  getData()
                } else if (e.target.value == 'document') {
                  form.setFieldsValue({
                    timeHead: DJparams.timeHead,
                    timeTail: DJparams.timeTail,
                    [DateRangeFieldName]: DJparams[DateRangeFieldName],
                  })
                  setPageLoading(true)
                  getDoctorAchievementDetail()
                  getPageColumnList()
                }
              }}
              optionType="button"
              buttonStyle="solid"
            >
              <Radio.Button value="summary">汇总</Radio.Button>
              <Radio.Button value="document">单据</Radio.Button>
            </Radio.Group>
            <Button type="primary" onClick={(() => {
              dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.DCDYQX }))
                .then(unwrapResult)
                .then((res: any) => {
                  if (viewType == 'summary') {
                    outClued()
                  } else {
                    exportExcel()
                  }
                })
            })} loading={exportLoading}>
              导出
            </Button>
            {viewType == 'summary' ?
              <Button type="primary"
                onClick={() => {
                  dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.DCDYQX }))
                    .then(unwrapResult)
                    .then((res: any) => {
                      printRef.current?.print()
                    })
                }}>
                打印
              </Button> :
              <> </>
            }
            <SettingOutlined
              style={{
                fontSize: '20px',
              }}
              onClick={() => {
                setSettingsVisible(true)
              }}
            />
          </Space>
        </Row>
      </Form>
      {
        viewType == 'summary' ? table() :
          <SimpleAgGrid
            page={{
              current: DJparams?.current || 1,
              size: DJparams?.size || 10,
              total: DJpage?.total,
              items: DJpage?.items,
            }}
            column={(AGColumns(
              DJparams?.size * (DJparams?.current - 1),
              allColumnList,
              CKHZSJHData
            ))?.filter((item: any) => filterSelectList?.includes(item.field))}
            isLoading={pageLoading}
            pagination={true}
            pageKey={'doctorAchievementPage'}
            // 配置底部行样式
            getRowStyle={(params) => {
              if (params.node.rowPinned) {
                return {
                  fontWeight: 'normal',
                  backgroundColor: '#D9F2FF',
                };
              }
              return {}; // 将返回 null 改为返回空对象，避免类型不匹配问题
            }}
            onChangePage={(current: any, size: any) => {
              setDJparams({
                ...DJparams,
                current,
                size,
              })
              setDJpage({
                ...DJpage,
                current,
                size,
              })
            }}
            onColumnResized={(v: any) => {
              return
            }}
            pinnedBottomRowData={[{
              totalPayAmount: summary?.totalPayAmount || 0.00,
              shouldPayAmount: summary?.shouldPayAmount || 0.00,
              realPayAmount: summary?.realPayAmount || 0.00,
              commissionAmount: summary?.commissionAmount || 0.00,
              billingCategory01: summary?.billingCategory01 || 0.00,
              billingCategory02: summary?.billingCategory02 || 0.00,
              billingCategory03: summary?.billingCategory03 || 0.00,
              billingCategory30: summary?.billingCategory30 || 0.00,
              billingCategory04: summary?.billingCategory04 || 0.00,
              billingCategory97: summary?.billingCategory97 || 0.00,
              billingCategory06: summary?.billingCategory06 || 0.00,
              billingCategory05: summary?.billingCategory05 || 0.00,
              billingCategory07: summary?.billingCategory07 || 0.00,
              billingCategory08: summary?.billingCategory08 || 0.00,
              billingCategory09: summary?.billingCategory09 || 0.00,
              billingCategory10: summary?.billingCategory10 || 0.00,
              billingCategory11: summary?.billingCategory11 || 0.00,
              billingCategory34: summary?.billingCategory34 || 0.00,
              billingCategory23: summary?.billingCategory23 || 0.00,
              billingCategory24: summary?.billingCategory24 || 0.00,
              billingCategory26: summary?.billingCategory26 || 0.00,
              billingCategory27: summary?.billingCategory27 || 0.00,
              billingCategory28: summary?.billingCategory28 || 0.00,
              billingCategory25: summary?.billingCategory25 || 0.00,
              billingCategory99: summary?.billingCategory99 || 0.00,
              // 剩余没有合计行的列展示为空
            }]}
            onColumnMoved={(v) => {
              // setPageLoading(true)
              const sortList = getSortColumnList(allColumnList, v);
              submitPageList(sortList)
              setAllColumnList(sortList)
            }}
          />
      }


      {/* 设置弹窗 */}
      <SettingsComputeModeModal
        viewType={viewType}
        visible={settingsVisible}
        onCancel={() => {
          setSettingsVisible(false)
        }}
        onOk={() => {
          setSettingsVisible(false)
          setPageLoading(true)
          getDoctorAchievementDetail()
          getPageColumnList()
        }}
      />

      <PrintFrame
        ref={printRef}
        title={
          JSON.parse(localStorage.getItem("credentials") as string)?.tenantName
        }
      >
        <Row style={{ lineHeight: "32px", textAlign: "right" }}>
          <Col span={13}>医生业绩统计</Col>
          <Col span={11}>
            日期：{form.getFieldValue("timeHead")?.split(" ")[0]} -{" "}
            {form.getFieldValue("timeTail")?.split(" ")[0]}
          </Col>
        </Row>
        {tablePrint(true)}
      </PrintFrame>
    </Col >
  )
}
